import { render, staticRenderFns } from "./LandingHead.vue?vue&type=template&id=c3492e8a&scoped=true"
import script from "./LandingHead.vue?vue&type=script&lang=js"
export * from "./LandingHead.vue?vue&type=script&lang=js"
import style0 from "./LandingHead.vue?vue&type=style&index=0&id=c3492e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3492e8a",
  null
  
)

export default component.exports